import { Auth, determineWebSocketURL, featureFlags } from '@evac/shared'
import { createApp, type App as VueApp } from 'vue'

import App from './App.vue'
import i18n from './i18n'
import { initializeRestConnector } from './rest'
import router from './router'
import handleServicesOverWebSocket, { primeServices } from './services'
import { storage } from './storage'
import './style.css'

initApp()

function initApp() {
  let app: VueApp | null = null
  app = createApp(App)
  app.use(Auth.plugin({ storage: storage.session }))
  app.use(featureFlags())
  // The debug switch used to live here; it is now the `debug` feature flag in localStorage.
  storage.indexedDb.removeItem('debug').catch(() => {})
  app.use(router)
  app.use(i18n)

  // Initialize REST endpoints before mount so route guards can use them
  initializeRestConnector()

  // Bind storage before mount so route-guard REST data survives the WS connect race
  primeServices()

  app.mount('#app')

  handleServicesOverWebSocket(determineWebSocketURL('/api/operator', window.location))
}
